<template lang="pug" src="./custom-fun-change.pug"></template>

<script>
export default {
  props: ['props'],
  mounted () {
    setTimeout(() => {
      this.$refs.fade.classList.add('custom-fun-change--fade')
    }, 450)
    setTimeout(() => {
      this.$refs.slide.classList.add('custom-fun-change__image--slide')
    }, 600)
  }
}
</script>



// WEBPACK FOOTER //
// custom-fun-change.vue?670b25ef